import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"
import IndexBloc from "./Blocs/IndexBloc"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Dropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem
} from "reactstrap"

import TableActiveComponent from './Components/TablePrimaryComponent'
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"

const IndexView = (props) => {

    let indexBloc = new IndexBloc();

    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const inactiveRef = useRef();
    const [fileUrl, setFileUrl] = useState("")    
    const [moreMenu, setMoreMenu] = useState(false)    

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                    <PegawaiSideBar active="riwayat_pendidikan"/>

                        <Card className="pegawai-rightbar">
                            <CardBody>
                                <div className="float-end">
                                {
                                    (accessRole('create')) ?
                                        // <Link to="?riwayat_pendidikan&create">
                                        //     <Button color="primary">Tambah Data</Button>
                                        // </Link>
                                        <Dropdown
                                            isOpen={moreMenu}
                                            toggle={() => {
                                                setMoreMenu(!moreMenu)
                                            }}
                                            className="btn-group me-2 mb-2 mb-sm-0"
                                            >
                                            <DropdownToggle
                                                className="btn btn-primary waves-light waves-effect dropdown-toggle"
                                                tag="div"
                                            >
                                                Tambah Data <i className="mdi mdi-chevron-down ms-2" />
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <Link to="?riwayat_pendidikan&create&type=riwayat">
                                                    <DropdownItem to="#">Riwayat Pendidikan</DropdownItem>
                                                </Link>
                                                <Link to="?riwayat_pendidikan&create&type=gelar">
                                                    <DropdownItem to="?riwayat_pendidikan&create&type=gelar">Pencantuman Gelar</DropdownItem>
                                                </Link>
                                            </DropdownMenu>
                                        </Dropdown>
                                    : null
                                }
                                
                                </div>
                                <CardTitle>Daftar Riwayat Pendidikan</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Riwayat Pendidikan
                                </CardSubtitle>
                                <hr />
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView